import React from 'react'
import Form from '../../components/Form/Form'

const LandingPage = () => {
  return (
    <>
    <h3>Welcome to your own Expense Tracker</h3>
    <h4>Please fill in below form to start tracking</h4>
    <Form/>
    </>
  )
}

export default LandingPage